module.exports = __webpack_public_path__ + "img/m6.39bbb223.png";